import EligibilityForm from "@/components/forms/EligibilityForm";

export default function EligibilitySection() {
  return (
    <section className="section-pad" id="eligibility" data-testid="home-eligibility">
      <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="overline">Eligibility check</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight">
            A 2-minute form. A real, honest answer.
          </h2>
          <p className="text-[#4A5568] mt-5 leading-relaxed">
            Tell us a little about your profile. We'll tell you whether your
            plan is realistic, what to prioritise, and where you might be
            wasting effort.
          </p>
          <ul className="mt-7 space-y-3 text-sm text-[#4A5568]">
            <li>· Personal review, not an auto-response</li>
            <li>· Straight answer within 1–2 business days</li>
            <li>· No pressure to book anything</li>
          </ul>
        </div>
        <div className="lg:col-span-7">
          <EligibilityForm />
        </div>
      </div>
    </section>
  );
}
